import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { getBrandForHost } from './branding/brandConfig'
import { BrandProvider } from './branding/BrandProvider'

// Basic runtime brand injection (title/meta + OG).
const brand = getBrandForHost(window.location.hostname)
document.title = `${brand.siteName} — ${brand.tagline}`
const metaDesc = document.querySelector('meta[name="description"]')
if (metaDesc) metaDesc.setAttribute('content', brand.metaDescription)
const ogTitle = document.querySelector('meta[property="og:title"]')
if (ogTitle) ogTitle.setAttribute('content', `${brand.siteName} — ${brand.tagline}`)
const ogSite = document.querySelector('meta[property="og:site_name"]')
if (ogSite) ogSite.setAttribute('content', brand.siteName)
const ogUrl = document.querySelector('meta[property="og:url"]')
if (ogUrl) ogUrl.setAttribute('content', brand.baseUrl)
const ogDesc = document.querySelector('meta[property="og:description"]')
if (ogDesc) ogDesc.setAttribute('content', brand.metaDescription)
const ogImg = document.querySelector('meta[property="og:image"]')
if (ogImg && brand.ogImagePath) ogImg.setAttribute('content', brand.ogImagePath)
const twitterTitle = document.querySelector('meta[name="twitter:title"]')
if (twitterTitle) twitterTitle.setAttribute('content', `${brand.siteName} — ${brand.tagline}`)
const twitterDesc = document.querySelector('meta[name="twitter:description"]')
if (twitterDesc) twitterDesc.setAttribute('content', brand.metaDescription)
const twitterImg = document.querySelector('meta[name="twitter:image"]')
if (twitterImg && brand.ogImagePath) twitterImg.setAttribute('content', brand.ogImagePath)
const canonical = document.querySelector('link[rel="canonical"]')
if (canonical) canonical.setAttribute('href', brand.baseUrl)

// Apply CSS variables for accents dynamically per brand
if (brand.accentHex) {
  document.documentElement.style.setProperty('--le-accent', brand.accentHex)
}
if (brand.accent2Hex) {
  document.documentElement.style.setProperty('--le-accent-2', brand.accent2Hex)
}

// Structured data (Organization + Website) injection/update
function upsertLdJson(id: string, json: Record<string, unknown>) {
  let script = document.getElementById(id) as HTMLScriptElement | null
  if (!script) {
    script = document.createElement('script')
    script.type = 'application/ld+json'
    script.id = id
    document.head.appendChild(script)
  }
  script.text = JSON.stringify(json)
}

upsertLdJson('ld-org', {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: brand.siteName,
  url: brand.baseUrl,
  logo: brand.logoPath || '/favicon.svg',
  sameAs: [],
})

upsertLdJson('ld-website', {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: brand.siteName,
  url: brand.baseUrl,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${brand.baseUrl}/?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrandProvider>
      <App />
    </BrandProvider>
  </React.StrictMode>,
)